<div class="login-screen">
  <div class="login-window">
    <div class="login-header">
      <div class="login-title">Login</div>
    </div>
    <div class="login-content">
      <div class="login-logo">
        <img src="assets/img/cyphergang.png" alt="Cypher Gang Logo" class="logo-icon">
        <h2>Welcome to the <h3 class="glow white">Cypher Syndicate</h3></h2>
      </div>
      <div class="login-instructions purple">
        Please connect your wallet to continue
      </div>
      <div class="login-button-container">
        <button
          class="connect-wallet-btn"
          (click)="connectWallet()"
          [disabled]="isConnecting()"
        >
          {{ isConnecting() ? 'Connecting...' : 'Connect Wallet' }}
        </button>
      </div>
    </div>
  </div>

  <div class="music-credit">
    <a href="https://www.fesliyanstudios.com" target="_blank" rel="noopener">
      Music by FesliyanStudios.com
    </a>
  </div>
</div>
